export function togglePasswordPreview() {
    const buttons = $(".js-password-preview");

    buttons.each((index, button) => {
        $(button).on("click", function () {
            const input = $(this).siblings("input");

            if (input.length === 0) return;

            const isPassword = input.attr("type") === "password";
            input.attr("type", isPassword ? "text" : "password");
            $(this).attr(
                "aria-label",
                isPassword ? "Prikaži password" : "Sakri password"
            );
            $(this).toggleClass("show");
        });
    });
}
